import React from 'react';
import PropTypes from 'prop-types';

import Card, { CardFooter } from "UI/Card";
import Skeleton from "UI/Skeleton";

export default class MediaCardSkeleton extends React.Component
{
    render()
    {
        return <Card tight className='overflow-hidden'>
            <Skeleton style={{paddingBottom: '100%'}} />
            <div className='p-4'>
                <div className='flex'>
                    <div className='flex-grow'>
                        <Skeleton className='h-6 w-3/4 rounded' />
                    </div>
                    <Skeleton className='h-6 w-2 mx-2 ml-2 rounded' />
                </div>
                <div className='flex mt-4'>
                    <Skeleton className='h-4 w-1/6 rounded' />
                    <div className='flex-grow' />
                </div>
            </div>
        </Card>;
    }
}
